import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowBottomRight"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3V10H19.5V4.5L4.5 4.5L4.5 19.5H10V21H3L3 3ZM11 9.93934L19.5 18.4393V13H21V21H13V19.5H18.4393L9.93934 11L11 9.93934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowBottomRight;
